import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IConfigurationHolder } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class SettingsService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/settings`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string): Observable<IConfigurationHolder> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<IConfigurationHolder>(baseRoute);
  }

  save(instanceId: string, settings: IConfigurationHolder): Observable<IConfigurationHolder> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.put<IConfigurationHolder>(baseRoute, settings);
  }

  hasChangedWhileRunning(instanceId: string): Observable<boolean> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<boolean>(`${baseRoute}/has-changed-while-running`);
  }
}
